import { jsx as _jsx } from "react/jsx-runtime";
import { useActionInstanceContext } from '../contexts';
export function ListDataRecord() {
    const { actionInstance } = useActionInstanceContext();
    return _jsx("div", { children: actionInstance.id });
}
//# sourceMappingURL=ListDataRecord.js.map